export const devAIWorkspaceContainerType = 'ati:cloud:devai:workspace';
export const rovoDevCLISettingsKey = 'rovo_dev_cli_settings';

export type RovoDevCLISettingValueKey = {
	rovo_dev_cli_enabled: boolean;
};

export type RovoDevCLISetting = {
	containerType: string;
	containerId: string;
	key: string;
	value: RovoDevCLISettingValue;
};

export type RovoDevCLISettingValue = {
	value: RovoDevCLISettingValueKey;
	lastUpdatedTime: Date | null;
};

export type SetRovoDevCLISetting = {
	containerId: string;
	value: boolean;
};

export type JiraProject = {
	id: string;
	key: string;
	name: string;
	webUrl: string;
};

export type AgentSettingsResponse = {
	success: boolean;
	settings: RovoDevCLISetting[];
};
